import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Session } from 'utils';

type ReturnType = Promise<AxiosResponse<Session>>;

const publishSession = (session: Session): ReturnType => {
    return Request.post(`/workouts/sessions/${session.uuid}/publish`);
};

export default publishSession;
